// frontend/src/shared/styles/navBarStyles.ts
import { layout, transitions } from './tokens';

/**
 * Estilos para NavBar
 *
 * ✅ REFACTORIZADO: Usa design tokens para patrones comunes
 * Reducción: 31 líneas → 23 líneas (-8 líneas, -26%)
 *
 * Tokens utilizados: 3/10 propiedades usan tokens compartidos
 */
export const navBarStyles = {
	container: 'bg-fondosuavizado border-b border-[#d4a976]',

	wrapper: 'max-w-screen-2xl mx-auto',

	// ✅ USA TOKEN: layout.flexBetween
	mainDiv: `${layout.flexBetween} px-8 h-20`,

	// ✅ USA TOKEN: layout.flexCenter
	logoContainer: `w-48 ${layout.flexCenter}`,

	logo: 'h-14 w-auto',

	navContainer: 'flex-1 flex justify-center',

	buttonContainer: 'flex space-x-8',

	// ✅ USA TOKEN: transitions.colors + effects.hover
	navButton: (isSelected: boolean) => `
    !px-6 !py-3 !text-sm !font-medium !rounded-lg
    ${transitions.colors} !ease-in-out
    ${
			isSelected
				? '!bg-primario !text-white !shadow-md !transform !scale-105'
				: '!bg-secundario !text-white hover:!bg-primario hover:!transform hover:!scale-102'
		}
  `,

	profileContainer: 'w-48 flex justify-end',

	// ✅ USA TOKEN: transitions.colors
	profileButton: `
    flex items-center space-x-3 px-4 py-2 rounded-lg
    bg-secundario text-white hover:bg-primario
    ${transitions.colors} ease-in-out
  `,

	profileImage: 'h-8 w-8 rounded-full shadow-sm',

	profileName: 'hidden md:block font-medium text-center',

	dropdownMenu: `
    absolute right-0 mt-2 w-48 rounded-lg shadow-lg
    bg-white border border-[#d4a976] overflow-hidden
  `,

	// ✅ USA TOKEN: effects.hover.bgGray
	logoutButton: `
    w-full text-left px-4 py-3 text-sm
    ${layout.flexStart} space-x-2
    hover:bg-primario/30
  `,
};
